module.exports = __webpack_public_path__ + "images/emoji/angel.14ed55bf9fcc40c90730.png";